<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>
<script>
import autofit from 'autofit.js'
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  },
  mounted() {
    // autofit.init({
    //   designHeight: 1080,
    //   designWidth: 1920,
    //   renderDom:"#app",
    //   resize: true
    // })
  },
}
</script>
<style scoped>
@import url('@/base.css');
#app {

  min-width: 1600px;
  height: 100%;
}

</style>
